import { type ReactNode } from 'react';

import { Box, Card, Stack, Typography } from '@mui/material';

/**
 * A card above the bar, holding text that is about to go: what a recording is
 * saying as it is said (LiveCaptionCard), or a card's lines being corrected.
 * One shell for both, so "this is your text, on its way" always looks the same.
 *
 * The header is a mark on the left, a title, and an action on the right; the
 * body is whatever the text is.
 */
const ComposerCard = ({
  mark,
  title,
  action,
  children,
}: {
  /** Small, before the title: the live dot, or a pencil. */
  mark: ReactNode;
  title: string;
  /** On the right of the header, like a way to stop. */
  action?: ReactNode;
  children: ReactNode;
}) => (
  <Card variant='padded' sx={{ width: '100%' }}>
    <Stack spacing={1.5}>
      <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1}>
        <Box sx={{ display: 'flex', flexShrink: 0 }}>{mark}</Box>
        <Typography sx={{ flex: 1 }} variant='subtitle1'>
          {title}
        </Typography>
        {action}
      </Stack>
      {children}
    </Stack>
  </Card>
);

ComposerCard.displayName = 'ComposerCard';
export default ComposerCard;
